import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/api/client";
import { getSelskaperOptions } from "@/api/generated/@tanstack/react-query.gen";

export const useLeverandoerData = () => {
  const query = useQuery({
    ...getSelskaperOptions({
      client: httpClient,
    }),
  });

  // Synchronous helper that always uses the latest data
  const getLeverandoerByOrgNr = (organisasjonsnummer: string | null) => {
    return (
      query.data?.selskaper?.find(
        (l) => l.organisasjonsnummer === organisasjonsnummer,
      ) || null
    );
  };

  return {
    ...query,
    data: query.data?.selskaper || [],
    getLeverandoerByOrgNr,
  };
};
